import React from 'react';
import { LockIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { checkoutUrl, mockupUrl, offerAnchor, productName } from '../data/content';
import { pricing } from '../data/bonuses';
import { Button } from './ui/Button';
import { OfferLink } from './ui/OfferLink';
export function FinalClose() {
  return <section className="bg-teal-800 px-4 py-12 md:py-16" data-id="element-65" data-mp="i60y636j74q0">
      <div className="mx-auto max-w-3xl text-center" data-id="element-66" data-mp="1fsq76wznihld">
        <p className="text-[11px] font-black uppercase tracking-[.25em] text-amber-300 md:text-xs" data-id="element-67" data-mp="1fs6pnhdwxv7v">One final question</p>
        <h2 className="mx-auto mt-3 max-w-2xl text-xl font-black uppercase leading-snug text-white md:text-3xl" data-id="element-68" data-mp="1avq1in6prgus">
          What if your next rehabilitation session was already organized?
        </h2>
        <p className="mx-auto mt-3 max-w-xl text-sm leading-relaxed text-white/85" data-id="element-69" data-mp="111r4g2lhyn9p">
          Instead of searching through scattered exercises, clinical notes, and different resources, access one
          professional system covering:
        </p>
        <p className="mx-auto mt-3 max-w-2xl text-sm font-black uppercase tracking-wider text-amber-300 md:text-base" data-id="element-70" data-mp="np2f9xptmz83">
          Postural Control. Gait Retraining. Functional Rehabilitation. Reactive Balance. Complete Clinical Sessions.
        </p>
        <p className="mx-auto mt-3 max-w-xl text-sm font-bold text-white" data-id="element-71" data-mp="dxevmiziamh6">
          Everything organized to support more structured rehabilitation planning.
        </p>

        <OfferLink className="mx-auto mt-8 max-w-[260px]" href={offerAnchor} label={`${productName} offer`} data-id="element-72" data-mp="4y1kzmznbruv">
          <img src={mockupUrl} alt={`${productName} 3D product mockup`} className="w-full object-contain drop-shadow-2xl transition-transform duration-300 ease-out group-hover:scale-[1.015]" data-id="element-73" data-mp="91zhdpxl6ok8" />
        </OfferLink>

        <p className="mt-6 text-lg font-black uppercase text-white md:text-xl" data-id="element-74" data-mp="1pe69vjdzvpyf">{productName}</p>
        <p className="mt-1 text-sm font-black uppercase tracking-wide text-amber-300" data-id="element-75" data-mp="1uear5bmq8opp">
          5 Complete Volumes + 5 Practical Bonuses
        </p>
        <p className="mt-2 text-sm text-white/85" data-id="element-76" data-mp="1sxwwscf175ij">Get the complete professional rehabilitation system today.</p>

        <p className="mt-6 text-xs font-black uppercase tracking-wide text-white/85" data-id="element-77" data-mp="1nzloi64dx32f">Instant access:</p>
        <p className="mt-1 text-4xl font-black text-white" data-id="element-78" data-mp="1j090vj5ovrys">
          ${pricing.price} <span className="text-base font-bold text-white/70" data-id="element-79" data-mp="1e15unvdz3fp8">USD</span>
        </p>
        <div className="mt-4" data-id="element-80" data-mp="2bls5vizp7v5b">
          <Button href={checkoutUrl} size="lg" subtext={`One-time payment of $${pricing.price} USD`} data-id="element-81" data-mp="2bp6akxvu4gfx">
            Get instant access now
          </Button>
        </div>
        <ul className="mt-5 flex flex-wrap justify-center gap-x-5 gap-y-2 text-[11px] font-bold uppercase tracking-wide text-white/85" data-id="element-82" data-mp="21vz2345sskbm">
          <li className="flex items-center gap-1.5" data-id="element-83" data-mp="1wwcpmwxsn83v">
            <ZapIcon className="h-4 w-4 text-amber-300" aria-hidden="true" data-id="element-84" data-mp="2uecugo8d7e3b" /> Instant Digital Delivery
          </li>
          <li className="flex items-center gap-1.5" data-id="element-85" data-mp="2plb8jw9qqea8">
            <ShieldCheckIcon className="h-4 w-4 text-amber-300" aria-hidden="true" data-id="element-86" data-mp="2xw0is8u6ns73" /> 7-Day Guarantee
          </li>
          <li className="flex items-center gap-1.5" data-id="element-87" data-mp="31wc5dr63w2l7">
            <LockIcon className="h-4 w-4 text-amber-300" aria-hidden="true" data-id="element-88" data-mp="31yx5obqraagu" /> Secure Payment
          </li>
        </ul>
      </div>
    </section>;
}